import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function NotFound() {
  const suggestions = [...comics].sort((a, b) => b.popularity - a.popularity).slice(0, 3);

  return (
    <div className="mx-auto flex w-full max-w-3xl flex-col items-center px-4 py-16 text-center md:px-6 md:py-24">
      <span className="flex h-20 w-20 items-center justify-center rounded-full bg-primary-100 text-primary-600">
        <i className="ri-emotion-sad-line text-4xl"></i>
      </span>
      <p className="mt-6 font-heading text-5xl text-primary-500 md:text-6xl">404</p>
      <h1 className="mt-3 text-2xl font-bold text-foreground-950 md:text-3xl">这个页面走丢了</h1>
      <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-500">
        你访问的页面可能已被移动或不存在。不妨回到首页，或看看下面这些热门双女主韩漫。
      </p>
      <div className="mt-6 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-4-line"></i>
          返回首页
        </Link>
        <Link
          to="/search"
          className="flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600"
        >
          <i className="ri-search-line"></i>
          搜索漫画
        </Link>
      </div>

      <div className="mt-12 grid w-full grid-cols-1 gap-4 sm:grid-cols-3">
        {suggestions.map((comic) => (
          <Link
            key={comic.id}
            to={`/detail/${comic.id}`}
            className="group flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-3 text-left transition-colors hover:border-primary-300"
          >
            <span className="h-16 w-12 shrink-0 overflow-hidden rounded-md bg-background-100">
              <img
                src={comic.cover}
                alt={`${comic.title}封面`}
                className="h-full w-full object-cover object-top"
              />
            </span>
            <span className="min-w-0">
              <span className="line-clamp-1 block text-sm font-semibold text-foreground-900 group-hover:text-primary-600">
                {comic.title}
              </span>
              <span className="line-clamp-1 block text-xs text-foreground-500">
                {comic.latestChapter}
              </span>
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
}